module.exports = __webpack_public_path__ + "img/ic_content-save.940ed8fd.svg";